import { ChartContainer } from '@/common/components/ui/chart';
import { ChartData } from '@/common/types/chart.type';
import { cn } from '@/common/utils/cn';
import { LineChart as LineChartComponent, CartesianGrid, Tooltip, XAxis, YAxis, Line } from 'recharts';
import CustomChartTooltip from '../ui/chartTooltip';
import { chartTickFormatters } from '@/common/utils/chartTickFormatter';
import { EmptyStateMessage } from '../EmptyStateMessage';

export interface LineChartProps {
  chartData: ChartData;
  className?: string;
}

export const LineChart = ({ chartData, className }: LineChartProps) => {
  return (
    <ChartContainer config={chartData.series_settings} className={cn('min-h-[200px] w-full', className)}>
      {!chartData.data.length ? (
        <EmptyStateMessage />
      ) : (
      <LineChartComponent
        data={chartData.data}
        {...{
          overflow: 'visible',
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />

        <XAxis
          dataKey={chartData.primary.query_identifier}
          tickMargin={4}
          angle={-90}
          interval={0}
          textAnchor="end"
          height={60}
          className='text-[10px]'
          tickFormatter={(value: string) =>
            value.length > 25 ? `${value.slice(0, 25)}...` : value
          }
        />

        <YAxis
          tick={{ fontSize: 10 }}
          domain={['dataMin - 0.1', 'dataMax + 0.1']}
          tickFormatter={
            chartData.tick_settings?.y?.format_parser
              ? chartTickFormatters[chartData.tick_settings?.y?.format_parser as keyof typeof chartTickFormatters]
              : undefined
          }
        />

        <Tooltip
          content={(props) => (
            <CustomChartTooltip {...props} seriesSettings={chartData.series_settings} />
          )}
        />

        {Object.values(chartData.series_settings).map(({ query_identifier, color }) => (
          <Line
            key={query_identifier}
            dataKey={query_identifier}
            type="monotone"
            stroke={color}
            strokeWidth={3}
            dot={false}
          />
        ))}
      </LineChartComponent>
      )}
    </ChartContainer>
  );
};
